import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { useDetailsConfiguredTicketProperty } from '../../utils/useDetailsConfiguredTicketProperty';
import { getIsPreview } from '../../utils/isPreview';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const InfoGridRow = ({
  configuredTicketProperty
}) => {
  const {
    propertyDisplayName,
    formattedPropertyValue
  } = useDetailsConfiguredTicketProperty(configuredTicketProperty.propertyName);
  const {
    isPreview
  } = getIsPreview();
  const hasValue = formattedPropertyValue != null;
  return (hasValue || isPreview) && /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "div",
      typography: "heading-25",
      color: "text-core-subtle",
      marginBlockEnd: "0",
      children: propertyDisplayName
    }), /*#__PURE__*/_jsx(Text, {
      as: "div",
      typography: "body-100",
      marginBlockEnd: "0",
      children: hasValue ? formattedPropertyValue : '—'
    })]
  });
};